import clsx from 'clsx';
import React from 'react';

import { kLabelColumnWidth } from '@fragment/ui/src/components/Payments/LayoutRow';

import { UserColorDot } from './UserColorDot';

type Props = {
  externalId: string;
  onClick?: (externalId: string) => void;
  /** Additional classes applied to the outer cell (e.g. `bg-negative` on hover). */
  className?: string;
  /** Align cell vertically. Defaults to centered for single-line rows. */
  align?: 'start' | 'center';
  /** Render the cell without the column separator (e.g. for header row). */
  withBorder?: boolean;
};

/**
 * Label column cell used by every invoice-detail table (Summary / Items /
 * Payments). Renders a stable per-user colored dot (seeded by `externalId`)
 * and the external_id inside a `kLabelColumnWidth` column with a right
 * border separator.
 */
export const UserLabelCell = ({
  externalId,
  onClick,
  className,
  align = 'center',
  withBorder = true,
}: Props): JSX.Element => (
  <div
    className={clsx(
      kLabelColumnWidth,
      'shrink-0 px-[13.5px] flex min-w-0',
      align === 'center' ? 'items-center' : 'items-start',
      withBorder && 'border-r-[0.5px] border-main-200',
      className
    )}
  >
    <div
      className={clsx(
        'flex items-center gap-x-f1 min-w-0',
        align === 'start' && 'h-[2lh]'
      )}
    >
      <UserColorDot seed={externalId} />
      {onClick ? (
        <button
          type="button"
          className="text-main text-xmd truncate hover:underline cursor-pointer"
          onClick={() => onClick(externalId)}
        >
          {externalId || '—'}
        </button>
      ) : (
        <span className="text-main text-xmd truncate">{externalId || '—'}</span>
      )}
    </div>
  </div>
);
